// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__Ve6RM","validationTips":"StatementDescriptor_validationTips__1vCB9"};